export default {
  DESKTOP: '1920px',
  LAPTOP: '1366px',
  TABLET: '1024px',
};
